import PropTypes from 'prop-types'

import { Badge } from '../elements/badge'

const STUDENT_CERTIFICATES = {
  'Not Started': 'outline',
  'In Progress': 'default',
  Issued: 'success',
  Expired: 'destructive',
}
const COURSE_RECORD = {
  'Not Started': 'outline',
  'In Progress': 'default',
  Completed: 'success',
}
const DOCUMENT_APPROVAL = {
  Pending: 'outline',
  Approved: 'success',
}
const EXTERNAL_CERTIFICATION = {
  Pending: 'outline',
  Approved: 'success',
  Denied: 'destructive',
}
/**
 * StatusBadge
 * @param {object} props
 * @param {string} props.status - The status to display
 * @param {string} [props.size=md] - The size of the badge (sm, md)
 * @param {'studentCertificate' | 'courseRecord' | 'documentApproval' | 'externalCertification'} props.type - The type of status badge
 * @returns {JSX.Element}
 */
function StatusBadge({ status, size = 'md', type }) {
  const typeMap = {
    studentCertificate: STUDENT_CERTIFICATES,
    courseRecord: COURSE_RECORD,
    documentApproval: DOCUMENT_APPROVAL,
    externalCertification: EXTERNAL_CERTIFICATION,
  }

  return (
    <Badge size={size} variant={typeMap[type][status] || 'secondary'}>
      {status}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf([
    'Not Started',
    'In Progress',
    'Completed',
    'Issued',
    'Expired',
    'Pending',
    'Approved',
    'Denied',
  ]).isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  type: PropTypes.oneOf([
    'studentCertificate',
    'courseRecord',
    'documentApproval',
    'externalCertification',
  ]).isRequired,
}
export default StatusBadge
